/*
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: 王佳宾
 * @LastEditTime: 2022-10-12 16:41:57
 * @Description: 数据管理表格配置
 * @FilePath: \src\components\DataManagement\management\tableConfig.js
*/
import config from '@/config/config';

const screenOperationConf = [1,];

const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '对应项目名称',
    dataIndex: 'propName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '区间ID',
    dataIndex: 'intervalIdentifier',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '钻孔ID',
    dataIndex: 'holeId',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '区间主矿种',
    dataIndex: 'primaryIntervalCommodity',
    ellipsis: true,
    align: 'center',
    width: 100,
  },
  {
    title: '区间全部矿种',
    dataIndex: 'intervalCommodities',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '钻孔类型',
    dataIndex: 'dillingType',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '区间深度',
    dataIndex: 'depthIntercept',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '区间长度',
    dataIndex: 'intervalLength',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '区间品位',
    dataIndex: 'intervalGrade',
    slots: { customRender: 'intervalGrade', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '区间价值',
    dataIndex: 'intervalValue',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '报告日期',
    dataIndex: 'reportedDate',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '勘测目的',
    dataIndex: 'explorationPurpose',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    width: screenOperationConf.includes(config.getPermissionId()) ? 240 : 120,
  },
];

export default tableConfig;
